// Currency formatter for Euro
export const formatEuro = (amount) => {
  if (amount === null || amount === undefined) return '€ 0';
  return new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

export const formatEuroDecimal = (amount) => {
  if (amount === null || amount === undefined) return '€ 0,00';
  return new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

// Percentage formatter
export const formatPercent = (value, decimals = 2) => {
  if (value === null || value === undefined) return '0%';
  return `${value.toFixed(decimals)}%`;
};

// Number formatter
export const formatNumber = (value, decimals = 0) => {
  if (value === null || value === undefined) return '0';
  return new Intl.NumberFormat('nl-NL', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
};

// Date formatter
export const formatDate = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('nl-NL', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(date);
};

export const formatDateShort = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('nl-NL', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(date);
};

// Square meters formatter
export const formatSqm = (value) => {
  if (value === null || value === undefined) return '0 m²';
  return `${formatNumber(value)} m²`;
};

// Get greeting based on time of day
export const getGreeting = (language = 'nl') => {
  const hour = new Date().getHours();
  if (language === 'nl') {
    if (hour < 12) return 'Goedemorgen';
    if (hour < 18) return 'Goedemiddag';
    return 'Goedenavond';
  }
  if (hour < 12) return 'Good morning';
  if (hour < 18) return 'Good afternoon';
  return 'Good evening';
};

// Asset class translation
export const getAssetClassLabel = (assetClass, language = 'nl') => {
  const labels = {
    nl: {
      residential: 'Residentieel',
      retail: 'Retail',
      light_industrial: 'Lichte Industrie',
      combination: 'Combinatie',
      logistics: 'Logistiek',
      other: 'Overig',
    },
    en: {
      residential: 'Residential',
      retail: 'Retail',
      light_industrial: 'Light Industrial',
      combination: 'Combination',
      logistics: 'Logistics',
      other: 'Other',
    },
  };
  return labels[language][assetClass] || assetClass;
};

// Calculate days until date
export const daysUntil = (dateString) => {
  if (!dateString) return null;
  const date = new Date(dateString);
  const today = new Date();
  const diffTime = date.getTime() - today.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
};

// Get status color based on days remaining
export const getExpiryStatus = (dateString) => {
  const days = daysUntil(dateString);
  if (days === null) return 'neutral';
  if (days < 0) return 'expired';
  if (days < 90) return 'warning';
  if (days < 365) return 'caution';
  return 'ok';
};
